import { TGroupedStackInfo } from 'types/state';
import { M8GroupedClientStack } from 'services/production/types';

export const normalizeM8GroupedClientStack = (stack: M8GroupedClientStack) => ({
  toGroupedStackInfo(): TGroupedStackInfo {
    return {
      id: stack.id,
      title: `${stack.numStack}`,
      activeStacksCount: stack.currentCountClientStacks,
      totalStacksCount: stack.maxCountClientStacks,
    };
  },
});
